angular
  .module('data-ng-todos')
  .factory('loadPathItemCommand', function loadPathItemCommand($http, defineCommand, PathItemBuilder) {
    return defineCommand('loadPathItemCommand', function loadPathItemCommand(deferred, eventId, repeatedBy) {
      $http
        .get('/event/task/event/' + eventId + '/repeated_by/' + repeatedBy + '/')
        .then(function ({ data }) {
          deferred.resolve(new PathItemBuilder(data));
        })
        .catch(function ({ error }) {
          deferred.reject(error);
        });
    });
  });



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-todos/src/data/commands/load_path_item_command.es.js